module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan4-1-b378f47fe52fb6b7cb131f0729b46eaa.webp";